import styled from "@emotion/styled";
import { BLUE_LIGHT, PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div`
  background: linear-gradient(
    137.88deg,
    rgba(204, 218, 255, 1) -65.41%,
    rgba(255, 255, 255, 1) 52.75%
  );
  border: 1px solid ${BLUE_LIGHT};
  box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: space-between;
  padding: 24px;
  max-width: 352px;
  width: 352px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
`;

export const HeaderTitleCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HeaderIcon = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin-right: 8px;
  width: 40px;
`;

export const HeaderTitle = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 20px;
  font-weight: 500;
`;

export const Amount = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 36px;
  font-weight: 500;

  &::before {
    content: "$";
  }
`;

export const FooterRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const UnitsCellContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 34px;
  padding: 0px 7px;
`;

export const VerticalDivider = styled.div`
  border-right: 1px solid ${BLUE_LIGHT};
  height: 100%;
  margin: 0px 14px;
`;

export const UnitsCellNumber = styled.div<{ type: "small" | "large" }>`
  color: ${PRIMARY_BLACK};
  font-size: ${(props) => (props.type === "large" ? 20 : 14)}px;
  font-weight: 600;
`;

export const UnitsCellLabel = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 10px;
`;
